module.exports = __webpack_public_path__ + "static/media/phone.70edac5b.svg";